<template>
  <div class="home">
    <About v-if="!isAuthorized"></About>
    <Searches v-if="searchId == -1 && isAuthorized" @searchSelected="searchId=$event"></Searches>
    <Listings v-if="searchId > -1 && isAuthorized" :searchId="searchId" @searchSelected="searchId=$event"></Listings>
  </div>
</template>

<script>
// @ is an alias to /src
import About from "@/components/about.vue"
import Listings from "@/components/listings.vue"
import Searches from "@/components/searches.vue"
// import SingleItem from "@/assets/single_item.json"
// import urlBase64ToUint8Array from "../../src/utilities.js"

export default {
  name: "home",
  data() {
    return {
      showSearches: true,
      searchId: -1
    }
  },
  components: {
    About,
    Listings,
    Searches /*,
    SingleItem */
  },
  computed: {
    isAuthorized() {
      return this.$store.state.isAuthorized
    },
    vapidPublicKey() {
      return this.$store.state.vapidPublicKey
    } /* ,
    searches () {
      return this.$store.state.userSearches
    } */
    /* singleItem () {
      return singleItem
    },
    localStartTime () {
      return this.setDateTimeFormat(singleItem.listingInfo[0].startTime[0])
    },
    localEndTime () {
      return this.setDateTimeFormat(singleItem.listingInfo[0].endTime[0])
    },
    listingType () {

      return 'something'
    },
    sellingPrice () {

      return '$1.00'
    } */
  },
  methods: {
    setDateTimeFormat(stringDateTime) {
      let dateTime = new Date(stringDateTime)

      let localDateTime = `${dateTime.toLocaleDateString("en-US")} ${dateTime.toLocaleTimeString("en-US")}`
      return localDateTime
    }
  },
  created() {
    // eslint-disable-next-line
    // console.log('Inside created...') // debug
    if (this.isAuthorized) {
      if ("serviceWorker" in navigator) {
        // Browser supports service workers
        let perms = Notification.permission
        // let vapidPublicKey = this.vapidPublicKey
        let userId = this.$store.state.userId
        if (perms === "default") {
          Notification.requestPermission(function(response) {
            if (response === "granted") {
              let options = {
                body: "Thank you for subscribing to our notification service.",
                icon: "favicon.ico"
              }
              navigator.serviceWorker.ready
                .then(function showNotify(swReg) {
                  return swReg.showNotification("MyListingBot Subscription Service", options)
                })
                /* .then(function configPushSub() {
                  let reg
                  navigator.serviceWorker.ready
                    .then(function getPushSub(swReg) {
                      reg = swReg
                      return swReg.pushManager.getSubscription()
                    })
                    .then(function readPushSub(pushSub) {
                      if (pushSub === null) {
                        // create new subscription
                        return reg.pushManager.subscribe({
                          userVisibleOnly: true,
                          applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
                        })
                      } else {
                        // eslint-disable-next-line
                        // console.log(pushSub) // debug
                        // eslint-disable-next-line
                        console.log('Push subscription did not succeed.')
                      }
                    })
                    .then(function storePushSub(pushSub) {
                      let body = {
                        user_id: userId,
                        subscription: pushSub
                      }
                      // console.log(JSON.stringify(body)) // debug

                      return fetch(`${process.env.VUE_APP_API_ROOT_URL}subscriptions/store/`, {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          "Accept": "application/json"
                        },
                        body: JSON.stringify(body)
                      })
                    })
                    .then(function confirmPushSub(response) {
                      // console.log(response.status) // debug
                      // console.log(response) // debug
                      return response.json()
                    })
                    .then(function readResponse(response) {
                      // eslint-disable-next-line
                      console.log(response)
                      // eslint-disable-next-line
                      console.log('Subscription added')
                    })
                }) */
                .then(function createPushySub() {
                  window.Pushy.register({
                      appId: process.env.VUE_APP_PUSHY_APP_ID
                  })
                  .then(function storePushyToken(token) {
                    // console.log(`Pushy device token ${token} for ${userId}`)
                    let body = {
                      user_id: userId,
                      subscription: token
                    }
                    // console.log(JSON.stringify(body)) // debug

                    return fetch(`${process.env.VUE_APP_API_ROOT_URL}subscriptions/store/`, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                      },
                      body: JSON.stringify(body)
                    })
                  })
                })
                .catch(function pushyError(err) {
                  /* eslint-disable-next-line */
                  console.error(err)
                })
            }
          })
        }
      }
    }

  }
};
</script>
